import { AttentionBanner, useScrollOnMount } from '@flos/react-ui';
import { useResourceBundle } from '../../contexts/ResourceContext';
import FormGroup from '../common/FormGroup';

const TimeSlotNotAvailable = () => {
  const resource = useResourceBundle();
  const anchor = useScrollOnMount<HTMLDivElement>({ offset: 180 });
  return (
    <FormGroup ref={anchor}>
      <AttentionBanner variant="error" className="u-spacing-stack-m">
        {resource['error.timeslot.unavailable']}
      </AttentionBanner>
    </FormGroup>
  );
};

export default TimeSlotNotAvailable;
